import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { MediaModule } from 'src/layout/media/media.module';
import { VideoElementComponent } from './video-element.component';



@NgModule({
    declarations: [VideoElementComponent],
    imports: [CommonModule, PipeModule, MediaModule, TagManagerModule],
    exports: [VideoElementComponent]
})
export class VideoElementModule {
    // tslint:disable: object-literal-key-quotes
    static references = {};
    static components = {
        'videoSpotElement': VideoElementComponent,
    };
    // tslint:enable: object-literal-key-quotes}
}
